export const BEDS = [1, 2, 3]
export const DIRECTIONS = ["N", "E", "S", "W"]
